import React from "react";
import ResponsiveWrapper from "../_responsive-wrapper";

const RadioProductsCards = ({ items, onChange, value }) => {
    if (!items) return null;

    return (
        <ResponsiveWrapper className="radio-products-cards">
            <div className="radio-products-cards__inner">
                {items?.map((item) => (
                    <label className="radio-products-cards__item" key={item.id}>
                        <input
                            type="radio"
                            checked={value === item.id}
                            onChange={() => onChange(item.id, item)}
                        />
                        <div className="radio-products-cards__item-inner">
                            <div className="radio-products-cards__item-image-wrapper">
                                <div className="radio-products-cards__item-image-ratio">
                                    <img className="radio-products-cards__item-image" src={item?.image} alt={item?.title} />
                                </div>
                            </div>
                            <div className="radio-products-cards__item-content">
                                <div className="radio-products-cards__item-title">
                                    {item?.title}
                                </div>
                                {parseFloat(item?.price) !== 0 && (
                                    <div className="radio-products-cards__item-price">
                                        $
                                        {item?.price}
                                    </div>
                                )}
                            </div>
                        </div>
                    </label>
                ))}
            </div>
        </ResponsiveWrapper>
    );
};

export default RadioProductsCards;
